<template>
  <div class="player">
    <div class="player-controls">
      <button>
        <svg fill="#000000" height="24" viewBox="0 0 24 24" width="24" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
          <defs>
            <path d="M0 0h24v24H0V0z" id="replay_a"/>
          </defs>
          <clipPath id="replay_b">
            <use overflow="visible" xlink:href="#replay_a"/>
          </clipPath>
          <path clip-path="url(#replay_b)" d="M12 5V1L7 6l5 5V7c3.3 0 6 2.7 6 6s-2.7 6-6 6-6-2.7-6-6H4c0 4.4 3.6 8 8 8s8-3.6 8-8-3.6-8-8-8zm-1.1 11H10v-3.3L9 13v-.7l1.8-.6h.1V16zm4.3-1.8c0 .3 0 .6-.1.8l-.3.6s-.3.3-.5.3-.4.1-.6.1-.4 0-.6-.1-.3-.2-.5-.3-.2-.3-.3-.6-.1-.5-.1-.8v-.7c0-.3 0-.6.1-.8l.3-.6s.3-.3.5-.3.4-.1.6-.1.4 0 .6.1c.2.1.3.2.5.3s.2.3.3.6.1.5.1.8v.7zm-.9-.8v-.5s-.1-.2-.1-.3-.1-.1-.2-.2-.2-.1-.3-.1-.2 0-.3.1l-.2.2s-.1.2-.1.3v2s.1.2.1.3.1.1.2.2.2.1.3.1.2 0 .3-.1l.2-.2s.1-.2.1-.3v-1.5z"/>
        </svg>
      </button>
      <button disabled>
        <svg fill="#000000" height="24" viewBox="0 0 24 24" width="24" xmlns="http://www.w3.org/2000/svg">
          <path d="M8 5v14l11-7z"/>
          <path d="M0 0h24v24H0z" fill="none"/>
        </svg>
      </button>
      <button disabled>
        <svg fill="#000000" height="24" viewBox="0 0 24 24" width="24" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
          <defs>
            <path d="M24 24H0V0h24v24z" id="forward_a"/>
          </defs>
          <clipPath id="forward_b">
            <use overflow="visible" xlink:href="#forward_a"/>
          </clipPath>
          <path clip-path="url(#forward_b)" d="M9.6 13.5h.4c.2 0 .4-.1.5-.2s.2-.2.2-.4v-.2s-.1-.1-.1-.2-.1-.1-.2-.1h-.5s-.1.1-.2.1-.1.1-.1.2v.2h-1c0-.2 0-.3.1-.5s.2-.3.3-.4.3-.2.4-.2.4-.1.5-.1c.2 0 .4 0 .6.1s.3.1.5.2.2.2.3.4.1.3.1.5v.3s-.1.2-.1.3-.1.2-.2.2-.2.1-.3.2c.2.1.4.2.5.4s.2.4.2.6c0 .2 0 .4-.1.5s-.2.3-.3.4-.3.2-.5.2-.4.1-.6.1c-.2 0-.4 0-.5-.1s-.3-.1-.5-.2-.2-.2-.3-.4-.1-.4-.1-.6h.8v.2s.1.1.1.2.1.1.2.1h.5s.1-.1.2-.1.1-.1.1-.2v-.5s-.1-.1-.1-.2-.1-.1-.2-.1h-.6v-.7zm5.7.7c0 .3 0 .6-.1.8l-.3.6s-.3.3-.5.3-.4.1-.6.1-.4 0-.6-.1-.3-.2-.5-.3-.2-.3-.3-.6-.1-.5-.1-.8v-.7c0-.3 0-.6.1-.8l.3-.6s.3-.3.5-.3.4-.1.6-.1.4 0 .6.1.3.2.5.3.2.3.3.6.1.5.1.8v.7zm-.9-.8v-.5s-.1-.2-.1-.3-.1-.1-.2-.2-.2-.1-.3-.1-.2 0-.3.1l-.2.2s-.1.2-.1.3v2s.1.2.1.3.1.1.2.2.2.1.3.1.2 0 .3-.1l.2-.2s.1-.2.1-.3v-1.5zM4 13c0 4.4 3.6 8 8 8s8-3.6 8-8h-2c0 3.3-2.7 6-6 6s-6-2.7-6-6 2.7-6 6-6v4l5-5-5-5v4c-4.4 0-8 3.6-8 8z"/>
        </svg>
      </button>
    </div>
    <div class="scrub">
      <input disabled type="range" value="0" min="0" max="100" :style="{ background: `linear-gradient( to right, #00cdbd 0%, #00cdbd 0%, #bfe0dd 0%, #bfe0dd 100% )` }"></input>
      <p class="playerInfo">Loading...</p>
    </div>
  </div>
</template>

<script>
export default {
  name: 'player-placeholder'
}
</script>

<style lang="sass" scoped>
@import ../../assets/styles/colors
@import ../../assets/styles/mixins

.player
  display: flex
  align-items: center
  +until($tablet)
    justify-content: center
    flex-wrap: wrap
    padding-top: 10px
  .player-controls
    display: flex
  button
    padding: 0
    display: flex
    align-items: center
    justify-content: center
    background: transparent
    height: auto
    &[disabled]
      svg
        fill: #aaa
      &.is-loading
        svg
          fill: transparent
    svg
      width: 24px
      height: 24px
      fill: #414042
      +until($tablet)
        width: 30px
        height: 30px
    &:nth-child(2)
      margin-left: 5px
      margin-right: 5px
      svg
        width: 36px
        height: 36px
        +until($tablet)
          width: 48px
          height: 48px

.scrub
  position: relative
  +until($tablet)
    flex-basis: 100%
  +tablet
    margin-left: 1rem
    flex: 1

h3
  width: 31.75%
  margin-left: 2.375%
  font-size: 20px
  padding-right: 75px

p.playerInfo
  position: absolute
  left: 0
  bottom: 4px
  width: 100%
  display: flex
  justify-content: space-between
  font-size: 15px
  span
    white-space: nowrap
    &:first-child
      flex: 1
      margin-right: 10px
      overflow: hidden
      text-overflow: ellipsis
    &:last-child
      min-width: 90px
      text-align: right

input[type=range]
  -webkit-appearance: none
  width: 100%
  margin: 10px 0 32px
  +tablet
    margin: 32px 0
input[type=range]:focus
  outline: none

input[type=range]::-webkit-slider-runnable-track
  width: 100%
  height: 8.9px
  cursor: pointer
  box-shadow: 1px 1px 1px rgba(0, 0, 0, 0), 0px 0px 1px rgba(13, 13, 13, 0)
  background: transparent
  border-radius: 1.3px
  border: 0px solid rgba(1, 1, 1, 0)

input[type=range]::-webkit-slider-thumb
  box-shadow: 0 0 4.3px rgba(0, 0, 0, 0.41)
  border: 1px solid rgba(0, 0, 0, 0)
  height: 24px
  width: 6px
  border-radius: 50px
  background: #414042
  cursor: pointer
  -webkit-appearance: none
  margin-top: -7.05px

input[type=range]:focus::-webkit-slider-runnable-track

input[type=range]::-moz-range-track
  width: 100%
  height: 8.9px
  cursor: pointer
  box-shadow: 1px 1px 1px rgba(0, 0, 0, 0), 0px 0px 1px rgba(13, 13, 13, 0)
  background: #00cdbd
  border-radius: 1.3px
  border: 0px solid rgba(1, 1, 1, 0)

input[type=range]::-moz-range-thumb
  box-shadow: 0 0 4.3px rgba(0, 0, 0, 0.41), 0px 0px 2.2px rgba(13, 13, 13, 0.41)
  border: 1px solid rgba(0, 0, 0, 0)
  height: 24px
  width: 6px
  border-radius: 50px
  background: #414042
  cursor: pointer

input[type=range]::-ms-track
  width: 100%
  height: 8.9px
  cursor: pointer
  background: transparent
  border-color: transparent
  color: transparent

input[type=range]::-ms-fill-lower
  background: #bfe0dd
  border: 0px solid rgba(1, 1, 1, 0)
  border-radius: 2.6px
  box-shadow: 1px 1px 1px rgba(0, 0, 0, 0), 0px 0px 1px rgba(13, 13, 13, 0)

input[type=range]::-ms-fill-upper
  background: #00cdbd
  border: 0px solid rgba(1, 1, 1, 0)
  border-radius: 2.6px
  box-shadow: 1px 1px 1px rgba(0, 0, 0, 0), 0px 0px 1px rgba(13, 13, 13, 0)

input[type=range]::-ms-thumb
  box-shadow: 2.2px 2.2px 4.3px rgba(0, 0, 0, 0.41), 0px 0px 2.2px rgba(13, 13, 13, 0.41)
  border: 1px solid rgba(0, 0, 0, 0)
  height: 27px
  width: 6px
  border-radius: 50px
  background: #414042
  cursor: pointer
  height: 8.9px

input[type=range]:focus::-ms-fill-lower
  background: #bfe0dd

input[type=range]:focus::-ms-fill-upper
  background: #00cdbd
</style>



// WEBPACK FOOTER //
// PlayerPlaceholder.vue?03ad99fc